export const dnfOrganizationCast = (item: any) => ({
  id: String(item.id),
  name: String(item.name),
  isOptedIn: Boolean(item.is_opted_in),
});

export type IDNFOrganization = ReturnType<typeof dnfOrganizationCast>;
